import { CircularProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withTheme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from '../../utils/config/constants';
import { cookies } from '../../utils/getToken';
import { Fade, DialogContent, Dialog } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';



class LoginDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            email: '',
            password: '',
            showCustomerVerification: false,
            showProviderVerification: false,
            closeVerification: false,
            playerId: '',
            showForgotPopup: false,
            samePage: false,
            role: '',
            customerRedirect: false,
            providerRedirect: false,
            countryCode: '1',
            phone: '',
            hideLogin: true,
            hideGetOtp: false,
            is_otp: true,
            timer: 10,
            accountType: "420",
            typeError: "",
            showChangePhone: false,
            phoneError: "",
            nameError: '',
            name: '',
            refferError: "",
            reffer: "",
            showSignUpModal: false

        };
    }

    componentDidUpdate() {
        if (this.state.timer === 0) {
            clearInterval(this.time)
        }

    }
    componentWillUnmount() {
        clearInterval(this.time)
    }
    renderLoginButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button type="submit"
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.proceedCall()}
                >
                    <FormattedMessage id="proceed" defaultMessage="Proceed" />
                </Button>
            );
        }
    };

    proceedCall = () => {
        this.setState({ loaderButton: true });
        axios({
            method: 'post',
            url: `${SERVER_URL}/otp/cverify`,
            data: {
                phone: this.state.phone,
                otp: this.state.password,
                playerId: window.onesignalId
            },
        }).then(resJson => {
            /* console.log("Adahvs a s a sjhasca:::", resJson) */
            if (resJson.data.status == "OK") {
                this.setState({
                    loaderButton: false,
                })
                if (resJson.data.data.existing_user) {
                    cookies.set('x-auth-token', resJson.data.data.token, { path: '/' });
                    this.props.history.push({
                        pathname: `/book/service/2912adarsh1245/`,
                        state: { serviceDataSource: this.props.serviceDataSource }
                    });
                } else {
                    this.setState({
                        showSignUpModal: true,
                    })
                }
            } else {
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    loaderButton: false,
                    password: "",
                })
            }
        })
    };

    renderGetOtpButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.getOptCall()}
                >
                    Get Otp
                </Button>
            );
        }
    };

    getOptCall = () => {
        if (this.state.accountType == "") {
            this.setState({
                typeError: "Choose account type!"
            })
        } else {
            if (this.state.phone.length != 10 & this.state.phone.length != 0) {
                this.setState({
                    phoneError: "phone length should be 10 *"
                })
            } else {
                this.setState({ loaderButton: true, timer: 60, showChangePhone: true });
                axios({
                    method: 'post',
                    // url: `${SERVER_URL}/otp/generate`,
                    url: `${SERVER_URL}/otp/login`, //new
                    data: {
                        country_code: this.state.countryCode,
                        phone: this.state.phone,
                        role: this.state.accountType //need to remove it 
                    },
                }).then(resJson => {
                    /* console.log("Adahvs a s a sjhasca:::", resJson) */
                    if (resJson.data.status == "OK") {
                        NotificationManager.success("Success", resJson.data.message)
                        this.time = setInterval(() => {
                            this.setState((prevState => ({
                                timer: prevState.timer - 1
                            })))
                        }, 1000)
                        this.setState({
                            loaderButton: false,
                            hideLogin: false,
                            hideGetOtp: true,
                            showVerifyBtn: true,
                            password: ""
                        })
                    } else {
                        NotificationManager.error("Oops!", resJson.data.message)
                        this.setState({
                            loaderButton: false,
                            password: "",
                            showChangePhone: false,
                        })
                    }
                })
            }
        }

    }


    renderSubmitButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.referVerify()}
                >
                    Submit
                </Button>
            );
        }
    };

    referVerify = () => {
        if (this.state.reffer == "") {
            this.signupActionCall()
        } else {
            axios({
                method: 'get',
                url: `${SERVER_URL}/promocodes/check-referral?code=${this.state.reffer}`,
            }).then(resJson => {
                if (resJson.data.status == "OK") {
                    this.signupActionCall()
                }
                else if (resJson.data.status == "NOK") {
                    this.setState({
                        refferError: resJson.data.message
                    })
                }
            })
        }
    }

    signupActionCall = () => {
        if (this.state.email == "") {
            NotificationManager.error(
                "Email field required!",
                'Oops!'
            );
        } else if (this.state.name == "") {
            NotificationManager.error(
                "please enter name",
                'Oops!'
            );
        } else {

            this.setState({ loaderButton: true });
            this.props.signupAction(
                {
                    name: this.state.name,
                    email: this.state.email,
                    otp: this.state.password,
                    phone: this.state.phone,
                    countryCode: this.state.countryCode,
                    playerId: window.onesignalId,
                    referral_code: this.state.reffer,
                    role: ROLE_CUSTOMER
                },
                this.onSignUpDone
            );
        }
    };

    onSignUpDone = (success, data) => {
        if (success) {
            cookies.set('x-auth-token', data.token, { path: '/' });
            this.props.history.push({
                pathname: `/book/service/2912adarsh1245/`,
                state: { serviceDataSource: this.props.serviceDataSource }
            });
            this.setState({
                loaderButton: false,
                showSignUpModal: false
            });
        } else {
            this.setState({
                loaderButton: false,
            });
            NotificationManager.error("Oops!", data.message)
        }

    }
    handleCloseLoginModal = () => {
        this.setState({
            password: "",
            passwordError: "",
            phone: "",
            hideLogin: true,
            hideGetOtp: false,
            is_otp: true,
            loaderButton: false
        }, () => { this.props.closeLoginModal() })
    }
    handleCloseSignUpModal = () => {
        this.setState({
            showSignUpModal: false,
        })
    }

    render() {

        const { passwordError, emailError, hideLogin, phoneError,
            refferError, loaderButton, nameError, } = this.state;
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <Dialog
                    fullWidth={true}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="login-modal"
                    open={this.props.showLoginModal}
                    onClose={this.handleCloseLoginModal}
                    aria-labelledby="form-dialog-title"
                >

                    <div className="md-12 pl-4 pr-1 verfitext"
                        style={{ height: 60, display: "flex", justifyContent: "space-between", width: "100%", background: this.props.colors.SECONDARY.HEX }}>
                        <h4 style={{ alignSelf: "center", color: "#ffffff" }}>Verify Mobile Number 11111</h4>
                        <Clear className="close_icon" style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                            this.handleCloseLoginModal()
                        }} />

                    </div>

                    <div>
                        <DialogContent>
                            <div className="log-in-pop-right">
                                
                                <h4>Mobile Number</h4>

                                <form
                                    className="s12 ng-pristine ng-valid form-new"
                                    autoComplete="off"

                                >
                                    <div
                                        className="dialog-header"
                                        style={{
                                            backgroundColor: this.props.theme
                                                .palette.primary.main
                                        }}
                                    />
                                    <div className="dialog-body">
                                        <div className="row" style={{ marginTop: -20 }}>

                                            <div className="col-md-12 mb-2">
                                                <TextField
                                                    error={phoneError ? true : false}
                                                    helperText={phoneError}
                                                    className="login-form-textfield"
                                                    label="Mobile"
                                                    id="phone"
                                                    fullWidth={true}
                                                    name="mobile"
                                                    type="number"
                                                    value={this.state.phone}
                                                    onChange={e => {
                                                        const re = /^[0-9\b]+$/;
                                                        if (e.target.value === '' || re.test(e.target.value) && e.target.value.length <= 10) {
                                                            this.setState({
                                                                phone: e.target.value,
                                                                phoneError: "",
                                                                error: ""
                                                            })
                                                        }
                                                    }}
                                                    disabled={this.state.loaderButton || this.state.hideGetOtp}
                                                    margin="normal"
                                                />

                                                {this.state.showChangePhone && (
                                                    <a className="mb-2" style={{ justifyContent: "flex-end", display: "flex" }} href="javascript:void(0);">
                                                        <p onClick={() => {
                                                            this.setState({
                                                                hideGetOtp: false,
                                                                hideLogin: true,
                                                                showChangePhone: false,
                                                                timer: 0
                                                            })
                                                        }}>
                                                            Change mobile number
                                                    </p>
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                        {!this.state.hideGetOtp &&
                                            <div className="d-flex justify-content-center md-12">
                                                {this.renderGetOtpButton()}
                                            </div>}
                                        {this.state.hideGetOtp &&
                                            <div className="input-field s12" style={{ marginTop: -20, display:"flex", flexDirection:"column" }}>
                                                <TextField
                                                    error={passwordError ? true : false}
                                                    helperText={passwordError}
                                                    className="login-form-textfield"
                                                    id="password"
                                                    fullWidth={true}
                                                    name="OTP"
						    type="number"
                                                    label={"One Time Password"}
                                                    value={this.state.password}
                                                    onChange={event => {
                                                        if (event.target.value.length <= 8) {
                                                            this.setState({
                                                                password:
                                                                    event.target.value,
                                                                passwordError: ''
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.loaderButton}
                                                    margin={'normal'}
                                                />
                                                <div 
                                                    style={{
                                                        display:"flex",
                                                        justifyContent:"end"
                                                      }}
                                                    className="input-field s12">
                                                    {!this.state.timer == 0 ? <a href="javascript:void(0);">
                                                        <p >
                                                            Resend otp 0:{this.state.timer}
                                                        </p>
                                                    </a> : <a href="javascript:void(0);">
                                                            <p onClick={() => {
                                                                this.getOptCall()
                                                            }}>
                                                                Resend
                                                    </p>
                                                        </a>}

                                                </div>
                                            </div>}

                                        {!hideLogin && <div className="sign-new-btn text-left">
                                            {this.renderLoginButton()}
                                        </div>}
                                    </div>
                                </form>
                            </div>
                        </DialogContent>
                    </div>
                </Dialog>


                {this.state.showSignUpModal && <Dialog
                    fullWidth={true}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="login-modal"
                    open={this.state.showSignUpModal}
                    onClose={this.handleCloseSignUpModal}
                    aria-labelledby="form-dialog-title"
                >

                    <div className="md-12 pl-2 pr-2"
                        style={{ height: 60, display: "flex", justifyContent: "space-between", width: "100%", background: this.props.colors.SECONDARY.HEX }}>
                        <h4 style={{ alignSelf: "center", color: "#ffffff" }}>Provide Additional Info</h4>
                        <Clear style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                            this.handleCloseSignUpModal()
                        }} />

                    </div>

                    <div>
                        <DialogContent>
                            <div className="log-in-pop-right">
                                <a
                                    href="#"
                                    className="pop-close"
                                    data-dismiss="modal"
                                />
                                <form
                                    className="s12 ng-pristine ng-valid form-new"
                                    autoComplete="off"

                                >
                                    <div
                                        className="dialog-header"
                                        style={{
                                            backgroundColor: this.props.theme
                                                .palette.primary.main
                                        }}
                                    />
                                    <div className="dialog-body">
                                        <div className="row" style={{ marginTop: -20 }}>

                                            <div className="col-md-12 mb-2">
                                                <TextField
                                                    error={nameError ? true : false}
                                                    helperText={nameError}
                                                    className="login-form-textfield"
                                                    label={formatMessage({
                                                        id: 'name'
                                                    })}
                                                    id="name"
                                                    fullWidth={true}
                                                    name="name"
                                                    type="text"
                                                    value={this.state.name}
                                                    onChange={event => {
                                                        this.setState({
                                                            name: event.target.value,
                                                            nameError: ''
                                                        });
                                                    }}
                                                    disabled={loaderButton}
                                                    margin="normal"
                                                />
                                            </div>
                                        </div>

                                        <div className="input-field s12" style={{ marginTop: -20 }}>
                                            <TextField
                                                error={emailError ? true : false}
                                                helperText={emailError}
                                                className="login-form-textfield"
                                                label={formatMessage({
                                                    id: 'email'
                                                })}
                                                id="email"
                                                fullWidth={true}
                                                name="email"
                                                type="email"
                                                value={this.state.email}
                                                onChange={event => {
                                                    this.setState({
                                                        email: event.target.value,
                                                        emailError: ''
                                                    });
                                                }}
                                                disabled={loaderButton}
                                                margin="normal"
                                            />
                                        </div>
                                        <div className="input-field s12" style={{ marginTop: -13 }}>

                                            <TextField
                                                error={refferError ? true : false}
                                                helperText={refferError}
                                                className="login-form-textfield"
                                                label={formatMessage({
                                                    id: 'enterReffer'
                                                })}
                                                id="reffercode"
                                                fullWidth={true}
                                                name="Reffer Code"
                                                type="text"
                                                value={this.state.reffer}
                                                onChange={event => {
                                                    this.setState({
                                                        reffer: event.target.value,
                                                        refferError: ''
                                                    });
                                                }}
                                                disabled={loaderButton}
                                                margin="normal"
                                            />
                                        </div>

                                        <div className="sign-new-btn text-left">
                                            {this.renderSubmitButton()}
                                        </div>
                                    </div>
                                </form>
                            </div>


                        </DialogContent>
                    </div>


                </Dialog>}

            </div>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    return { settings, colors: settings.colors };
};
const composedHOC = compose(
    withTheme(),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedHOC(injectIntl(withRouter(LoginDialog)));



// WEBPACK FOOTER //
// ./src/components/Dialogs/LoginDialog.jsx